import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { IPrograma } from "../ProgramaListagem";
import Personalizacoes, { IPersonalizacao } from "./Personalizacoes";
import ProgramaDefinicaoCard from "./ProgramaDefinicaoCard";
import { IResposta } from "./ProgramaDefinicaoCustom";

interface ProgramaCreateModalProps {
  show: boolean;
  onHide: Function;
  onSave: (success: boolean, programa?: IPrograma) => void;
}

export function ProgramaCreateModal({
  show,
  onHide,
  onSave,
}: ProgramaCreateModalProps) {
  const [alvos, setAlvos] = useState<{ nome: string }[]>([]);
  const [titulo, setTitulo] = useState("");
  const [categoriaId, setCategoriaId] = useState<number>();
  const [respostas, setRespostas] = useState<IResposta[]>([]);
  const [personalizacoes, setPersonalizacoes] = useState<IPersonalizacao[]>([])

  const handleCreate = async (
    titulo: string,
    categoria: number | string,
    alvos: any,
    respostas: IResposta[],
    personalizacoes : IPersonalizacao[]
  ) => {
    const programa: IPrograma = (
      await axios.post("/programa", {
        titulo,
        categoria_id: categoria,
        alvos,
        respostas,
        personalizacoes
      })
    ).data;

    return programa;
  };

  const limparFormulario = () => {
    setTitulo("");
    setCategoriaId(undefined);
    setAlvos([]);
    setRespostas([]);
  };

  return (
    <Modal
      size="xl"
      show={show}
      onHide={() => {
        limparFormulario();
        onHide();
      }}
    >

      <Modal.Header closeButton>
        <Modal.Title>Criar Programa</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ProgramaDefinicaoCard
          titulo={titulo}
          setTitulo={setTitulo}
          categoriaId={categoriaId}
          setCategoriaId={setCategoriaId}
          alvos={alvos}
          setAlvos={setAlvos}
          respostas={respostas}
          setRespostas={setRespostas}
        />

        <Personalizacoes 
          personalizacoes={personalizacoes}
          setPersonalizacoes={setPersonalizacoes} 
        />

        <div className="mt-3 d-flex justify-content-end">
          <Button
            onClick={async () => {
              try {
                const prog = await handleCreate(
                  titulo,
                  categoriaId!,
                  alvos,
                  respostas,
                  personalizacoes
                );
                onSave(true, prog);
                limparFormulario();
                onHide();
              } catch {
                onSave(false);
              }
            }}
          >
            Salvar
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}